import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "href", "onClick", "open", "children", "tokens"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import ToggleLinkContent from '../ToggleLinkContent';
import useToggleLink from '../useToggleLink';
import ToggleIcon from '../ToggleIcon';
import * as views from './PrimaryLink.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var BasePrimaryLink = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var title = _ref.title,
      href = _ref.href,
      onClick = _ref.onClick,
      open = _ref.open,
      children = _ref.children,
      tokens = _ref.tokens,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useToggleLink = useToggleLink(open),
      getTriggerProps = _useToggleLink.getTriggerProps,
      getContentProps = _useToggleLink.getContentProps;

  var isDropdown = typeof open === "boolean";
  return _jsxs(views.Wrapper, {
    children: [_jsxs(views.PrimaryLink, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      onClick: onClick
    }, getTriggerProps({
      href: href
    })), tokens), rest), {}, {
      children: [title, isDropdown && _jsx(ToggleIcon, {
        open: open
      })]
    })), isDropdown && _jsx(ToggleLinkContent, _objectSpread(_objectSpread({}, getContentProps()), {}, {
      open: open,
      children: children
    }))]
  });
});
var PrimaryLink = withDesignTokens(BasePrimaryLink, function (_props, theme) {
  return {
    color: theme.palette.twilio.gray[100],
    backgroundColor: theme.palette.neutrals.white[100],
    borderBottomColor: theme.palette.twilio.gray[20],
    openColor: theme.palette.twilio.blue[60],
    openBackgroundColor: theme.palette.twilio.gray[10]
  };
}, {
  light: function light() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  twilioLight: function twilioLight() {
    return {};
  }
});
export default PrimaryLink;